export const VALIDATION_MESSAGE = {
  LOGIN: {
    ADMIN: {
      ADM_ID: {
        REQUIRED: '관리자ID 입력해 주세요.',
        MIN_LENGTH: '5 ~ 20자까지 입력할 수 있습니다.',
        MAX_LENGTH: '5 ~ 20자까지 입력할 수 있습니다.',
        ONLY_UPPER_LOWER_NUM:
          '영어 대문자, 영어소문자, 숫자만 입력할 수 있습니다.',
      },
      ADM_PWD: {
        REQUIRED: '비밀번호 입력해 주세요.',
        MIN_LENGTH: '9 ~ 20자까지 입력할 수 있습니다.',
        MAX_LENGTH: '9 ~ 20자까지 입력할 수 있습니다.',
        ATLEAST_UPPER_LOWER_NUM_SPECIAL:
          '영어 대문자, 영어소문자, 숫자, 특수문자 각 1개 이상 조합해야 합니다.',
        ATLEAST_UPPER: '영어 대문자를 입력해 주세요.',
        ATLEAST_LOWER: '영어 소문자를 입력해 주세요.',
        ATLEAST_NUMBER: '숫자를 입력해 주세요.',
        ATLEAST_SPECIAL: '특수문자를 입력해 주세요.',
      },
    },
  },

  ACCOUNT_INFO: {
    ADMIN: {
      INFO_INQUIRY: {},
      CHANGE_PASSWORD: {
        CURRENT_PWD: {
          REQUIRED: '비밀번호 입력해 주세요.',
          MIN_LENGTH: '9 ~ 20자까지 입력할 수 있습니다.',
          MAX_LENGTH: '9 ~ 20자까지 입력할 수 있습니다.',
          ATLEAST_UPPER_LOWER_NUM_SPECIAL:
            '영어 대문자, 영어소문자, 숫자, 특수문자 각 1개 이상 조합해야 합니다.',
          ATLEAST_UPPER: '영어 대문자를 입력해 주세요.',
          ATLEAST_LOWER: '영어 소문자를 입력해 주세요.',
          ATLEAST_NUMBER: '숫자를 입력해 주세요.',
          ATLEAST_SPECIAL: '특수문자를 입력해 주세요.',
        },
        NEW_PWD: {
          REQUIRED: '변경할 비밀번호 입력해 주세요',
          MIN_LENGTH: '9 ~ 20자까지 입력할 수 있습니다.',
          MAX_LENGTH: '9 ~ 20자까지 입력할 수 있습니다.',
          ATLEAST_UPPER_LOWER_NUM_SPECIAL:
            '영어 대문자, 영어소문자, 숫자, 특수문자 각 1개 이상 조합해야 합니다.',
          ATLEAST_UPPER: '영어 대문자를 입력해 주세요.',
          ATLEAST_LOWER: '영어 소문자를 입력해 주세요.',
          ATLEAST_NUMBER: '숫자를 입력해 주세요.',
          ATLEAST_SPECIAL: '특수문자를 입력해 주세요.',
        },

        CONFIRM_PWD: {
          REQUIRED: '변경하려면 확인 비밀번호를 입력하세요.',
          NOT_MATCH_WITH_NEW_PWD: '비밀번호가 일치하지 않습니다.',
        },
      },
    },
  },

  CUSTOMER_DELIVERY: {
    REGISTER_FILE: {
      SUBJECT: {
        REQUIRED: '업로드 제목 입력해 주세요.',
        MIN_LENGTH: '3 ~ 100자까지 입력할 수 있습니다.',
        MAX_LENGTH: '3 ~ 100자까지 입력할 수 있습니다.',
      },
      EXPIRATION_YMD: {
        REQUIRED: '만료일자 입력해 주세요',
        ALLOWED_DATE_FORMAT: 'yyyy-mm-dd 형식만 허용 (ex. 2024-04-20)',
      },
      AUTH_PWD: {
        MIN_LENGTH: '4 ~ 20자까지 입력할 수 있습니다.',
        MAX_LENGTH: '4 ~ 20자까지 입력할 수 있습니다.',
        ATLEAST_UPPER_LOWER_NUM_SPECIAL:
          '영어 대문자, 영어소문자, 숫자, 특수문자 각 1개 이상 조합해야 합니다.',
        ATLEAST_UPPER: '영어 대문자를 입력해 주세요.',
        ATLEAST_LOWER: '영어 소문자를 입력해 주세요.',
        ATLEAST_NUMBER: '숫자를 입력해 주세요.',
        ATLEAST_SPECIAL: '특수문자를 입력해 주세요.',
      },
    },
  },
  EXTERNAL_DELIVERY: {
    REGISTER_FILE: {
      SUBJECT: {
        REQUIRED: '업로드 제목 입력해 주세요.',
        MIN_LENGTH: '3 ~ 100자까지 입력할 수 있습니다.',
        MAX_LENGTH: '3 ~ 100자까지 입력할 수 있습니다.',
      },
    },
    UPDATE_FILE: {
      SUBJECT: {
        REQUIRED: '업로드 제목 입력해 주세요.',
        MIN_LENGTH: '3 ~ 100자까지 입력할 수 있습니다.',
        MAX_LENGTH: '3 ~ 100자까지 입력할 수 있습니다.',
      },
    },
  },
  DOWNLOAD: {
    CUSTOMER_DELIVERY: {
      FILEPWD: {
        REQUIRED: '파일 비밀번호 입력해 주세요.',
        MIN_LENGTH: '4 ~ 20자까지 입력할 수 있습니다.',
        MAX_LENGTH: '4 ~ 20자까지 입력할 수 있습니다.',
        ATLEAST_UPPER_LOWER_NUM_SPECIAL:
          '영어 대문자, 영어소문자, 숫자, 특수문자 각 1개 이상 조합해야 합니다.',
        ATLEAST_UPPER: '영어 대문자를 입력해 주세요.',
        ATLEAST_LOWER: '영어 소문자를 입력해 주세요.',
        ATLEAST_NUMBER: '숫자를 입력해 주세요.',
        ATLEAST_SPECIAL: '특수문자를 입력해 주세요.',
      },
    },
  },

  SYSTEM: {
    PREFERENCES: {
      VERSION: {
        REQUIRED: 'CSS,JS 버전 입력해 주세요.',
        MIN_LENGTH: '3 ~ 20자까지 입력할 수 있습니다.',
        MAX_LENGTH: '3 ~ 20자까지 입력할 수 있습니다.',
        ONLY_UPPER_LOWER_NUM:
          '영어 대문자, 영어소문자, 숫자 만 입력할 수 있습니다.',
      },
      S3_DOWNLOAD_URL_VALUE: {
        REQUIRED: 'S3다운로드URL 유지(분)값을  입력해 주세요.',
        MIN_LENGTH: "'1 ~ 4자까지 입력할 수 있습니다",
        MAX_LENGTH: "'1 ~ 4자까지 입력할 수 있습니다",
        ONLY_NUM: '숫자만 입력할 수 있습니다.',
      },
    },
    MANAGER: {},
  },
};
